export const getS3Url = (fileName) => {
  // https://badgeheroes.s3.amazonaws.com/webapp/5_Screenshot%202016-12-28%2018.22.11.png
  const parsedFileName = encodeURIComponent(fileName)
  const bucketName = 'badgeheroes'
  const amazonUrl = '.s3.amazonaws.com'
  const folderName = '/webapp/'
  return `https://${bucketName}${amazonUrl}${folderName}${parsedFileName}`
}

export const getS3Url2 = (fileName) => {
  // https://badgeheroes.s3.amazonaws.com/webapp/5_Screenshot%202016-12-28%2018.22.11.png
  const bucketName = 'badgeheroes'
  const amazonUrl = '.s3.amazonaws.com'
  const folderName = 'webapp'
  return `https://${bucketName}${amazonUrl}${folderName}${fileName}`
}

export const isLoggedIn = () => (localStorage.getItem('access_token')
  !== null && localStorage.getItem('access_token') !== undefined)



// WEBPACK FOOTER //
// ./src/utils/utils.jsx